import { Link } from "react-router-dom";
import { allMedia } from "@/lib/media";

const entries = [
  {
    to: "/category/movie",
    type: "movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "动作、科幻、爱情、悬疑，一次看个够",
  },
  {
    to: "/category/tv",
    type: "tv",
    icon: "ri-live-line",
    title: "电视剧",
    desc: "古装、都市、犯罪、家庭，追剧不停歇",
  },
  {
    to: "/category/variety",
    type: "variety",
    icon: "ri-mic-line",
    title: "综艺",
    desc: "音乐、竞技、美食、真人秀，快乐加倍",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {entries.map((entry) => {
        const count = allMedia.filter((item) => item.type === entry.type).length;
        return (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-background-50 transition-colors group-hover:bg-primary-700">
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="flex items-center gap-1.5 text-base font-semibold text-foreground-950">
                {entry.title}
                <i className="ri-arrow-right-s-line text-base text-primary-600 transition-transform group-hover:translate-x-0.5"></i>
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-600">{entry.desc}</p>
              <p className="mt-1 text-xs font-medium text-accent-700">{count} 部作品</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}